import { useAuth } from "./AuthContext";

export function useAuthHeaders(json = false) {
  const { accessToken } = useAuth();
  const headers: Record<string, string> = { Accept: "application/json" };
  if (json) headers["Content-Type"] = "application/json";
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  return headers;
}

export function useAuthedFetch() {
  const { accessToken, refresh, logout, getAuthVersion, isAuthVersionCurrent } = useAuth();
  return async (input: RequestInfo | URL, init: RequestInit = {}) => {
    const requestAuthVersion = getAuthVersion();
    const headers = new Headers(init.headers);
    if (accessToken) headers.set("Authorization", `Bearer ${accessToken}`);
    let res = await fetch(input, { ...init, headers, credentials: "include" });
    if (res.status !== 401) return res;
    if (!isAuthVersionCurrent(requestAuthVersion)) return res;

    const nextToken = await refresh({ clearOnFailure: false });
    if (nextToken === undefined) return res;
    if (!nextToken) {
      if (!isAuthVersionCurrent(requestAuthVersion)) return res;
      await logout();
      return res;
    }
    if (!isAuthVersionCurrent(requestAuthVersion)) return res;
    headers.set("Authorization", `Bearer ${nextToken}`);
    res = await fetch(input, { ...init, headers, credentials: "include" });
    if (res.status === 401 && isAuthVersionCurrent(requestAuthVersion)) await logout();
    return res;
  };
}
